
import ApiService from "@/core/services/ApiService";
import { defineComponent, ref } from "vue";
import { hideModal } from "@/core/helpers/dom";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { useBus } from "../../../../bus";

export default defineComponent({
  name: "add_info",
  components: {},
  props: {
    data: { type: Object },
  },
  setup() {
    const formData = ref({
      id: "",
      registration_number: "",
      registration_authority: "",
      postcode: "",
      sub_district: "",
      district: "",
      division: "",
      email: "",
      entity_name: "",
      entity_short_name: "",
      telephone: "",
    });
    const formRef = ref<null | HTMLFormElement>(null);
    const addModalRef = ref<null | HTMLElement>(null);
    const loading = ref<boolean>(false);
    const update = ref<boolean>(false);
    const rules = ref({
      entity_name: [
        {
          required: true,
          message: "Entity Name is required",
          trigger: "change",
        },
      ],
      entity_short_name: [
        {
          required: true,
          message: "Entity Short Name is required",
          trigger: "change",
        },
      ],
      email: [
        {
          required: true,
          message: "Email is required",
          trigger: "change",
        },
      ],
      telephone: [
        {
          required: true,
          message: "Telephone is required",
          trigger: "change",
        },
      ],
      registration_number: [
        {
          required: true,
          message: "Registration Number is required",
          trigger: "change",
        },
      ],
      registration_authority: [
        {
          required: true,
          message: "Registration Authority is required",
          trigger: "change",
        },
      ],
      postcode: [
        {
          required: true,
          message: "Postcode is required",
          trigger: "change",
        },
      ],
      sub_district: [
        {
          required: true,
          message: "Sub District is required",
          trigger: "change",
        },
      ],
      district: [
        {
          required: true,
          message: "District is required",
          trigger: "change",
        },
      ],
      division: [
        {
          required: true,
          message: "Division is required",
          trigger: "change",
        },
      ],
    });
    const { bus } = useBus();

    bus.on("edit-modal-data", (data) => {
      update.value = true;
      formData.value = data;
    });

    bus.on("add-modal-data", () => {
      update.value = false;
      formData.value = {
        id: "",
        registration_number: "",
        registration_authority: "",
        postcode: "",
        sub_district: "",
        district: "",
        division: "",
        entity_name: "",
        entity_short_name: "",
        email: "",
        telephone: "",
      };
    });

    const submit = () => {
      if (!formRef.value) {
        return;
      }

      formRef.value.validate(async (valid) => {
        if (valid) {
          loading.value = true;
          const action = update.value ? "update" : "post";
          const url = update.value
            ? "entity/infos/" + `${formData?.value?.id}`
            : "entity/infos";

          await ApiService[action](url, formData.value)
            .then((response) => {
              loading.value = false;
              bus.emit("role-updated", true);
              if (response.status == 200) {
                Swal.fire({
                  text: response.data.message,
                  icon: "success",
                  buttonsStyling: false,
                  confirmButtonText: "Ok",
                  customClass: {
                    confirmButton: "btn btn-primary",
                  },
                }).then(() => {
                  hideModal(addModalRef.value);
                });
              } else {
                let err = "";
                for (const field of Object.keys(response.data.errors)) {
                  err += response.data.errors[field][0] + "<br>";
                }
                Swal.fire({
                  html: err,
                  icon: "error",
                  buttonsStyling: false,
                  confirmButtonText: "Close",
                  customClass: {
                    confirmButton: "btn btn-danger",
                  },
                });
              }
            })
            .catch(({ response }) => {
              loading.value = false;
              console.log(response);
            });
        }
      });
    };

    return {
      formData,
      rules,
      submit,
      formRef,
      loading,
      addModalRef,
    };
  },
  data() {
    return {
      entityTypes: [],
    };
  },
  async created() {
    await this.getTypes();
  },
  methods: {
    async getTypes() {
      await ApiService.get("entity/types")
        .then((response) => {
          this.entityTypes = response.data;
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
  },
});
